<template>
  <section class="header-search">
    <Field v-model="keywords" placeholder="请输入关键词">
      <template #button>
        <Button size="small" icon="search" round type="primary" @click="goSearch"></Button>
      </template>
    </Field>
  </section>
</template>
<script>
import { ref } from 'vue'
import { Field, Button } from 'vant'
import { useRouter } from 'vue-router'
import 'vant/es/field/style'
import 'vant/es/button/style'

export default {
  name: 'mHeaderSearch',
  components: { Field, Button },
  props: {
    close: {
      type: Function,
      default: () => null
    }
  },
  setup (props) {
    const router = useRouter()
    const keywords = ref('')
    const goSearch = () => {
      router.push(`/search/${keywords.value}`)
      props.close()
    }
    return {
      keywords,
      router,
      goSearch
    }
  }
}
</script>
